import { Injectable } from '@angular/core';
import { SupportedLanguages } from '@as/api';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { AppConfigurationService } from './modules/commons/configurations/services/app-configuration.service';
import { ITranslations, TranslationsLoader } from './translations-loader';

export function AppTranslationsFactory(translationInitService: TranslationInitializationService) {
  return (): Promise<unknown> => {
    return translationInitService.initializeTranslations();
  };
}

@Injectable({
  providedIn: 'root'
})
export class TranslationInitializationService {
  constructor(
    private translate: TranslateService,
    private appConfigurationService: AppConfigurationService,
    private translationsLoader: TranslationsLoader
  ) {}

  initializeTranslations(): Promise<unknown> {
    return new Promise((resolve, reject) => {
      const checkConfigLoaded = () => {
        if (this.appConfigurationService.configuration.apiUrl) {
          const lang = localStorage.getItem('language') || SupportedLanguages.PL;
          firstValueFrom(this.translationsLoader.getTranslation(lang))
            .then((translations: ITranslations) => {
              this.translate.setTranslation(lang, translations);
              this.translate.use(lang);
              resolve(true);
            })
            .catch(error => {
              reject(error);
            });
        } else {
          setTimeout(checkConfigLoaded, 100);
        }
      };
      checkConfigLoaded();
    });
  }
}
